import classnames from 'classnames';
import React, { FC } from 'react';
import styles from './LinkIcon.scss';
import { IOuter } from './LinkIcon.types';

export const LinkIcon: FC<IOuter> = ({ isSecondaryColor }) => (
  <div className={classnames(styles.linkIcon, isSecondaryColor && styles.secondary)} />
);
